import { Button, Col, Logo, Row } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Navigation } from './';

const Wrapper = styled(Col)`
  width: 100%;

  @media (min-width: 1024px) {
    align-items: center;
  }

  @media (max-width: 1024px) {
    width: 100vw;
    justify-content: flex-start;
  }
`;

const ContentArea = styled(Row)`
  padding: 55px 0 25px;
  width: 1140px;

  @media (max-width: 1024px) {
    padding: 36px 16px 22px;
    width: unset;
  }
`;

const Header = (props) => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { isMobile } = useSelector((state) => state.appState);
  const location = useLocation();
  const { t } = useTranslation();

  if (location.pathname.includes('admin')) return null;

  return (
    <Wrapper>
      <ContentArea between center>
        <Logo />

        <Row center>
          {user ? (
            <Row center gap={isMobile ? '15px' : '25px'}>
              <Button
                pad={isMobile ? '0 18px' : '0 24px'}
                text={t('website.goToApp')}
                onClick={() =>
                  navigate(user.type === 'athlete' ? (isMobile ? '/home' : '/dashboard') : '/home')
                }
              />
            </Row>
          ) : (
            <Button
              website
              sportsSelect
              isMobile
              marg="0 20px 0"
              text={t('website.login')}
              onClick={() => navigate('/login')}
            />
          )}

          <Navigation />
        </Row>
      </ContentArea>
    </Wrapper>
  );
};

export default Header;
